/* #203 YouTube facade: descriptions and articles ship their YouTube iframes with data-yt-src instead of src
   (see snippets/youtube-lite.liquid). We show the video thumbnail + play button and only load the ~1 MB
   YouTube player when the visitor presses play. */
(function () {
  function init(iframe) {
    var src = iframe.getAttribute('data-yt-src');
    var match = src && src.match(/\/embed\/([A-Za-z0-9_-]{6,})/);
    if (!match) {
      iframe.setAttribute('src', src);
      return;
    }
    var id = match[1];
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'yt-lite';
    button.setAttribute('aria-label', iframe.getAttribute('title') || 'Play video');
    button.style.backgroundImage = 'url(https://i.ytimg.com/vi/' + id + '/hqdefault.jpg)';
    button.innerHTML = '<span class="yt-lite_play" aria-hidden="true"></span>';
    button.addEventListener('click', function () {
      iframe.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
      iframe.classList.add('yt-lite_frame');
      button.replaceWith(iframe);
    }, { once: true });
    iframe.replaceWith(button);
  }

  function run() {
    document.querySelectorAll('iframe[data-yt-src]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
